import { useEffect } from 'react';
import { OperatorPinLockScreen } from '@shared/components/operator';
import { useOperatorInactivity } from '@shared/hooks/useOperatorInactivity';
import { useUserData } from '@shared/hooks/useUser';
import { useOperationalNavigationStore } from '@shared/navigation/operationalNavigationStore';
import { useAuthStore } from '@shared/stores/authStore';
import { useBottomBannerStore } from '@shared/stores/bottomBannerStore';

export function OperatorInactivityProvider() {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const role = useAuthStore((state) => state.role);
  const team = useAuthStore((state) => state.team);
  const isImpersonating = useAuthStore((state) => state.isImpersonating);
  const timeoutMinutes = useAuthStore((state) => state.getOperatorsInactivityTimeoutMinutes());
  const canRefresh = Boolean(token && role && team?.type === 'tenant_3pl' && !isImpersonating);
  useUserData({ refetchInterval: canRefresh ? 60_000 : false, refetchOnWindowFocus: canRefresh ? 'always' : false });
  const { isLocked, unlockSession } = useOperatorInactivity({
    enabled: Boolean(
      token &&
      role &&
      team?.type === 'tenant_3pl' &&
      user?.is_operator &&
      user.has_unlock_pin &&
      timeoutMinutes > 0 &&
      !isImpersonating,
    ),
    timeoutMinutes,
    userId: user?.id ?? null,
  });
  useEffect(() => {
    useOperationalNavigationStore.setState({ securityPaused: isLocked });
    return () => {
      useOperationalNavigationStore.setState({ securityPaused: false });
    };
  }, [isLocked]);
  function handleUnlock() {
    unlockSession();
    useBottomBannerStore.getState().setInactivityWarningVisible(false);
  }
  if (!token || !role || !team) return null;
  return isLocked ? <OperatorPinLockScreen onUnlock={handleUnlock} /> : null;
}
